import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';

import IxBottomNav from '../../basic/ix-bottom-nav';
import NxtTopBar from '../../basic/nxt-top-bar';
import NxtTopBarItems from '../../composite/nxt-top-bar-items';
import { redirectToSearch, dateAndTimeGenerator } from '../../../services/utility';
import {
  yellowBaseColor,
  blackLikeBackground
} from '../../../constants/theme-colors';
import { fetchOrderedMenus } from '../../business/menu/menuSlice';

const useStyles = makeStyles(theme => ({
  bottomNav: {
    bottom: '0',
    position: 'fixed',
    width: '100%',
    marginLeft: '0em',

    zIndex: theme.zIndex.bottomNav
  },
  listWrapper: {
    color: blackLikeBackground,
    paddingTop: theme.spacing(2),
    marginTop: '2rem'
  },
  listSegmentTitle: {
    background: 'rgb(0 0 0 / 8%)',
    height: '4rem',
    '& .MuiTypography-body1': {
      fontSize: '1rem',
      fontWeight: 400,
      color: '#424949'
    }
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgb(0 0 0 / 10%)',
    borderTop: '1px solid rgb(0 0 0 / 10%)',
    cursor: 'pointer'
  },
  listItemSecondColumn: {
    textAlign: 'right'
  },
  orderNo: {
    fontSize: '1.1rem',
    fontWeight: 400
  },
  pending: {
    color: '#FF7733 ',
    fontSize: '.9rem',
    fontWeight: 400
  },
  ready: {
    color: '#52D063',
    fontSize: '.9rem',
    fontWeight: 400
  },
  completed: {
    color: 'rgb(166 172 175)',
    fontSize: '.9rem',
    fontWeight: 400
  },
  orderTime: {
    color: 'rgb(166 172 175)'
  },
  orderPrice: {
    fontWeight: 900,
    color: '#000000'
  },
  // listItemContainer: {
  //   overflowY: 'scroll', 
  //   height: '70vh'
  // }
}));

const TakeoutOrderList = props => {
  const classes = useStyles();
  const { history } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(['common']);
  const orderedMenus = useSelector(state => state.menuState.orderedMenus.data);

  useEffect(() => {
    dispatch(fetchOrderedMenus()); 
  }, []);

  const orderStatus = status => {
    if (status.pickupStatus === 'COMPLETED') {
      return t('Completed');
    } else if (status.pickupStatus === 'PENDING') {
      return t('Pending');
    } else {
      return t('Ready for pick up');
    }
  };

  let todaysOrder = orderedMenus?.filter(e => {
    let dateAndTime = new Date(e.orderStartTime);
    let allOrderTime = moment(dateAndTime).format('D MMM, YYYY');
    let today = moment().format('D MMM, YYYY');
    return today === allOrderTime;
  });
  let previousOrder = orderedMenus?.filter(e => {
    let dateAndTime = new Date(e.orderStartTime);
    let allOrderTime = moment(dateAndTime).format('D MMM, YYYY');
    let today = moment().format('D MMM, YYYY');
    return today !== allOrderTime;
  });

  return (
    <div>
      <Box className={classes.bottomNav} component='span'>
        <IxBottomNav props={props}></IxBottomNav>
      </Box>

      <div>
        <NxtTopBar>
          <NxtTopBarItems
            title={t('mnOrders')}
            titleAlignment='left'
            handleSearchButton={() => redirectToSearch(history)}
          ></NxtTopBarItems>
        </NxtTopBar>
      </div>

      <List className={classes.listWrapper}>
        {todaysOrder && todaysOrder.length > 0 && (
          <ListItem button className={classes.listSegmentTitle}>
            <ListItemText primary={t('Pending Orders')} />
          </ListItem>
        )}
        {todaysOrder && todaysOrder.length > 0 && (<div>
        {todaysOrder?.map((e, i) => (
          <div className={classes.listItem} key={i} onClick={() => history.push(`/order-detail/${e.id}`)}>
            <ListItem>
              <ListItemText
                classes={{
                  primary: classes.orderNo,
                  secondary: orderStatus(e) === 'Pending' ? classes.pending : orderStatus(e) === 'Completed' ? classes.completed : classes.ready
                }}
                primary={t('Order')+` #${e.displayOrderNo}`}
                secondary={orderStatus(e)}
              />
            </ListItem>

            <ListItem>
              <ListItemText
                classes={{
                  primary: classes.orderTime,
                  secondary: classes.orderPrice
                }}
                className={classes.listItemSecondColumn}
                primary={dateAndTimeGenerator(e)}
                secondary={`￥${e.totalDecimal}`}
              />
            </ListItem>
          </div>
        ))}
        </div>
        )}

        {previousOrder && previousOrder.length > 0 && (
          <ListItem button className={classes.listSegmentTitle}>
            <ListItemText primary={t('Previous Orders')} />
          </ListItem>
        )}

        {previousOrder?.map((e, i) => (
          <div className={classes.listItem} key={i} onClick={() => history.push(`/order-detail/${e.id}`)}>
            <ListItem>
              <ListItemText
                classes={{
                  primary: classes.orderNo,
                  secondary: orderStatus(e) === 'Pending' ? classes.pending : orderStatus(e) === 'Completed' ? classes.completed : classes.ready
                }}
                primary={t('Order')+` #${e.displayOrderNo}`}
                secondary={orderStatus(e)}
              />
            </ListItem>

            <ListItem>
              <ListItemText
                classes={{
                  primary: classes.orderTime,
                  secondary: classes.orderPrice
                }}
                className={classes.listItemSecondColumn}
                primary={dateAndTimeGenerator(e)}
                secondary={`￥${e.totalDecimal}`}
              />
            </ListItem>
          </div>
        ))}
      </List>
    </div>
  );
};

export default TakeoutOrderList;
